import EstimatedTasksEvAHTMLPreviewStrategy from './EstimatedTasksEvAHTMLPreviewStrategy'
import AllTasksEvAHTMLPreviewStrategy from './AllTasksEvAHTMLPreviewStrategy'
import {ReportGroupingLevel} from '../../../constants'
import EstimateVsActualHTMLPreviewHeaderSection from './EstimateVsActualHTMLPreviewHeaderSection'
import EstimateVsActualHTMLPreviewGroupingSection from './EstimateVsActualHTMLPreviewGroupingSection'

export default function EstimateVsActualHTMLPreviewGenerator() {}

EstimateVsActualHTMLPreviewGenerator.prototype.init = function()
{
    return this;
};

EstimateVsActualHTMLPreviewGenerator.prototype.generatePreviewTable = function( reportParameters )
{
    const table = document.createElement("table")
    const tBody = document.createElement("tbody")
    table.appendChild( tBody );
    
    const groupingLevelsArray = [
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        reportParameters.thirdGroupingLevel,
        reportParameters.fourthGroupingLevel
    ];

    const filteredLevelsArray = ReportPreviewUtils.filterNotEmptyLevels(groupingLevelsArray)
    const columnsStrategy = this.createPreviewStrategy(reportParameters)

    const headerSection = new EstimateVsActualHTMLPreviewHeaderSection().init(filteredLevelsArray, columnsStrategy)

    const reportAuthorizationInfo = reportParameters.reportAuthorizationInfo
    const groupingSection = new EstimateVsActualHTMLPreviewGroupingSection().init(
        filteredLevelsArray,
        reportParameters.fourthGroupingLevel !== ReportGroupingLevel.NONE,
        columnsStrategy,
        reportParameters.timeFormat,
        reportAuthorizationInfo,
    )

    headerSection.addRows( tBody );
    groupingSection.addRows( tBody );

    table.className = "reportHtmlPreviewTable eva " + columnsStrategy.getTableClass();
    
    return table;
};

EstimateVsActualHTMLPreviewGenerator.prototype.createPreviewStrategy = function ( reportParameters )
{
    if ( reportParameters.includeNotEstimated )
        return new AllTasksEvAHTMLPreviewStrategy().init(reportParameters.timeFormat);
    
    return new EstimatedTasksEvAHTMLPreviewStrategy().init(reportParameters.timeFormat);
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/html/eva/EstimateVsActualHTMLPreviewGenerator.js